import { deleteUser } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";

import { useAuth } from "@/contexts/auth/useAuth";
import { Tooltip } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";
import { useNavigate } from "react-router";

interface IProps {
    userId: number;
}

export const DeleteUserButton = ({ userId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();
    const { user } = useAuth();
    const navigate = useNavigate();

    const dialogProps: DestructiveDialogProps = {
        itemId: userId,
        subject: "user",
        mutationFn: deleteUser,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-users"],
            });
            navigate("/admin/users");
        },
    };

    const handleClick = () => {
        dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <Tooltip
            title={
                user?.id === userId
                    ? "You cannot delete yourself"
                    : "Delete User"
            }
        >
            <span>
                <Button
                    variant="text"
                    color="error"
                    sx={{ borderRadius: 29 }}
                    disableElevation
                    onClick={handleClick}
                    disabled={user?.id === userId}
                >
                    Delete
                </Button>
            </span>
        </Tooltip>
    );
};
